package com.hyperether.goodjob.scenes.addNew

import androidx.compose.runtime.MutableState
import com.hyperether.resources.stringResourcePlain
import com.hyperether.goodjob.repository.remote.model.DayHours
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.friday
import com.hyperether.goodjob.resources.monday
import com.hyperether.goodjob.resources.saturday
import com.hyperether.goodjob.resources.sunday
import com.hyperether.goodjob.resources.thursday
import com.hyperether.goodjob.resources.tuesday
import com.hyperether.goodjob.resources.wednesday

data class DaySchedule(
    val dayInt: Int,
    val isChecked: MutableState<Boolean>,
    val startTime: MutableState<String>,
    val endTime: MutableState<String>,
    val isStartTimePickerVisible: MutableState<Boolean>,
    val isEndTimePickerVisible: MutableState<Boolean>
) {
    fun toDayHours(): DayHours {
        return DayHours(
            enabled = isChecked.value,
            from = if (isChecked.value) startTime.value else null,
            to = if (isChecked.value) endTime.value else null
        )
    }

    fun getName(): String {
        return when(this.dayInt) {
            0-> stringResourcePlain(Res.string.monday)
            1-> stringResourcePlain(Res.string.tuesday)
            2-> stringResourcePlain(Res.string.wednesday)
            3-> stringResourcePlain(Res.string.thursday)
            4-> stringResourcePlain(Res.string.friday)
            5-> stringResourcePlain(Res.string.saturday)
            6-> stringResourcePlain(Res.string.sunday)
            else -> {""}
        }
    }

}